/**
 * i18n configuration — THE GRID · Public Internationalization V1.
 *
 * Lightweight, zero-dependency internal i18n. English is the canonical
 * source. Architecture allows adding ZH / JA / KO / TR later by dropping a
 * new locale dictionary + LOCALES entry — nothing else changes.
 */
export type Locale = "en" | "es" | "pt-br" | "fr" | "de" | "it" | "ru";

export interface LocaleMeta {
  code: Locale;
  /** Native language name shown in the dropdown. */
  label: string;
  /** Compact code shown in the nav control (e.g. "EN"). */
  short: string;
}

/** Display order in the selector (per product spec). */
export const LOCALES: LocaleMeta[] = [
  { code: "en", label: "English", short: "EN" },
  { code: "es", label: "Español", short: "ES" },
  { code: "pt-br", label: "Português (Brasil)", short: "PT" },
  { code: "fr", label: "Français", short: "FR" },
  { code: "de", label: "Deutsch", short: "DE" },
  { code: "it", label: "Italiano", short: "IT" },
  { code: "ru", label: "Русский", short: "RU" },
];

export const DEFAULT_LOCALE: Locale = "en";
export const STORAGE_KEY = "thegrid.locale";

const SUPPORTED = new Set<string>(LOCALES.map((l) => l.code));

/** Validate a stored/candidate locale; fall back to English when invalid. */
export function normalizeLocale(candidate: string | null | undefined): Locale {
  if (candidate && SUPPORTED.has(candidate)) return candidate as Locale;
  return DEFAULT_LOCALE;
}
